<template>
  <el-dialog title="转商机" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%" >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="135px">
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>客户信息</span>
        </div>
        <el-form-item label="客户名称:" prop="customerName">
          <span>{{data.customerName}}</span>
        </el-form-item>
      </el-card>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>联系人信息</span>
        </div>
        <el-form-item label="联系人:" prop="contactName">
          <span>{{data.contactName}}</span>
        </el-form-item>
        <el-form-item label="角色:" prop="role">
          <el-select v-model="data.role" placeholder="请选择" clearable style="width:100%">
            <el-option v-for="dict in roleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
      </el-card>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>商机</span>
        </div>
        <el-form-item label="商机名称:" prop="businessName">
          <el-input v-model="data.businessName" :maxlength="32" placeholder="请输入商机名称" clearable/>
        </el-form-item>
        <el-form-item label="商机级别:" prop="businessLevel">
          <el-select v-model="data.businessLevel" placeholder="请选择商机级别" clearable style="width:100%">
            <el-option v-for="stage in businessLevelOptions" :key="stage.dictValue" :label="stage.dictLabel" :value="stage.dictValue"/>
          </el-select>
          <el-popover placement="right" title="商机级别" width="410" trigger="hover">
            <div>
              A类商机：需满足3个条件，搞定人、搞定事、1个月内签约。<br>
              B类商机：需满足3个条件，搞定人、搞定事、2个月内签约。<br>
              C类商机：人和事都没搞定。<br>
              D类商机：商机项目待定，且人和事看未搞定。
            </div>
            <el-button slot="reference" type="text">商机级别说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="商机来源:" prop="businessSource">
          <el-select v-model="data.businessSource" placeholder="请选择商机来源" allow-create filterable clearable style="width:100%">
            <el-option v-for="dict in businessSourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
        <el-form-item label="商机规模:" prop="businessScale">
          <el-select v-model="data.businessScale" placeholder="请选择商机规模" clearable style="width:100%">
            <el-option v-for="item in businessScaleOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
          </el-select>
          <el-popover placement="right" title="商机规模（金额）" width="200" trigger="hover">
            <div>
              甲：300万及以上<br>
              乙：100万-300万<br>
              丙：50万-100万<br>
              丁：50万以下
            </div>
            <el-button slot="reference" type="text">商机规模说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="商机负责人:" prop="assignUserId">
          <UserSelect v-model="data.assignUserId" placeholder="请选择商机负责人"></UserSelect>
        </el-form-item>
        <el-form-item label="采购需求:" prop="requirements">
          <el-select v-model="data.requirements" placeholder="请选择采购需求" clearable multiple style="width:100%">
            <el-option v-for="stage in requirementOptions" :key="stage.value" :label="stage.label" :value="stage.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型:" prop="projectType">
          <el-select v-model="data.projectType" placeholder="请选择项目类型" clearable style="width:100%">
            <el-option v-for="stage in projectTypeOptions" :key="stage.dictValue" :label="stage.dictLabel" :value="stage.dictValue"/>
          </el-select>
          <el-popover
            v-if="data.projectType==1"
            placement="right"
            title="难降解工业废水类别说明"
            width="400"
            trigger="hover">
            <span>医疗废水；制药废水；化工废水；垃圾渗滤液；印染废水；实验室废水；食品废水；养殖废水；屠宰废水；餐厨废水；饮料废水；电子废水；光伏废水；乳液废水</span>
            <el-button v-if="data.projectType==1" slot="reference" type="text">难降解工业废水类别说明</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="项目区域:" prop="area">
          <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址:" prop="address">
          <el-input type="textarea" v-model="data.address" :maxlength="200" show-word-limit placeholder="请输入详细地址" clearable/>
        </el-form-item>
        <el-form-item label="预计成交金额:" prop="estimateDealAmount">
          <el-input-number v-model="data.estimateDealAmount" placeholder="请输入预计成交金额" :precision="2" :controls="false" clearable class="crm-input-number-wrap"/>
          <span class="el-input__suffix">元</span>
        </el-form-item>
        <el-form-item label="预计成交时间:" prop="estimateDealDate">
          <el-date-picker v-model="data.estimateDealDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="data.remark" :maxlength="1000" placeholder="请输入1000字以内备注" show-word-limit clearable/>
        </el-form-item>
      </el-card>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getUser } from "@/api/system/user";
import {queryClueDetail, convertToBusiness} from "@/api/crm/clue";
import { queryCustomerByName } from "@/api/crm/customer";
import { queryContactByCustomerId} from "@/api/crm/contact";
import { businessNameCheck } from "@/api/crm/business";
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import {transferCascaderOptionsForProvince} from "@/utils";
import {listAllLevelArea} from "@/api/crm/area";
import {queryProductTypeList2} from "@/api/crm/contract";

export default {
  name: "ClueToBusinessDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      businessLevelOptions: [],
      businessSourceOptions: [],
      businessScaleOptions: [],
      requirementOptions: [],
      projectTypeOptions: [],
      contactList: [],
      areaOptions: [],
      roleOptions: [], // 角色列表
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'change'}
        ],
        customerName: [
          {required: true, trigger: 'change'}
        ],
        contactName: [
          {required: true, trigger: 'change'}
        ],
        businessLevel: [
          {required: true, message: '请选择商机级别', trigger: 'change'}
        ],
        businessSource: [
          {required: true, message: '请选择商机来源', trigger: 'change'}
        ],
        businessScale: [
          {required: true, message: '请选择商机规模', trigger: 'change'}
        ],
        assignUserId: [
          {required: true, message: '请选择商机负责人', trigger: 'change'}
        ],
        requirements: [
          {required: true, message: '请选择采购需求', trigger: 'change'}
        ],
        projectType: [
          {required: true, message: '请选择项目类型', trigger: 'change'}
        ],
        // area: [
        //   {required: true, message: '请选择项目区域', trigger: 'change'}
        // ],
        address: [
          {max: 200, message: '详细地址最大200个字符', trigger: 'change'}
        ],
        businessName: [
          {required: true, validator: this.checkBusiness, trigger: 'blur'},
          {max: 32, message: '长度过长', trigger: 'change'}
        ],
        estimateDealAmount: [
          {required: true, type:'number', message: '请输入预计成交金额', trigger: 'blur'}
        ],
        estimateDealDate: [
          {required: true, message: '请选择预计成交时间', trigger: 'change'}
        ]
      },
      data: {
        businessName: null,
        clueId: null,
        companyId: null,
        customerId: null,
        customerName: null,
        contactName: null,
        estimateDealAmount: undefined,
        estimateDealDate: null,
        businessLevel: null,
        businessSource: null,
        businessScale: null,
        requirements: [],
        projectType: null,
        area: [],
        address: null,
        remark: null,
        provinceCode: null,
        cityCode: null,
        regionCode: null
      }
    };
  },
  created() {
    this.getDicts("business_contact_role").then(response => {
      this.roleOptions = response.data;
    });
    this.getDicts("business_level").then(response => {
      this.businessLevelOptions = response.data;
    });
    this.getDicts("common_source").then(response => {
      this.businessSourceOptions = response.data;
    });
    this.getDicts("business_scale").then(response => {
      this.businessScaleOptions = response.data;
    });
    queryProductTypeList2({}).then(response => {
      this.requirementOptions = response.data || [];
    })
    this.getDicts("project_type").then(response => {
      this.projectTypeOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  components: {
    UserSelect,
    CompanyInput
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (clueId) {
      this.data.clueId = clueId
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      queryClueDetail({id:clueId}).then(response => {
        this.data.clueId = clueId;
        this.data.assignUserId = response.data.managerId;
        this.data.companyId = response.data.companyId;
        this.data.customerName = response.data.customerName;
        this.data.contactName = response.data.contactName
        this.handleCompanyChange(this.data.customerName, this.data.companyId, true)
        loading.close()
        this.visible = true
      }).catch(error => {
        loading.close()
      })

    },
    customerChange (customerId) {
      this.contactList = []
      if (customerId) {
        if (this.data.businessName != null) {
          this.$refs['addForm'].validateField('businessName');
        }
        queryContactByCustomerId({customerId: customerId}).then(response => {
          this.contactList = response.data;
        });
      }
    },
    handleCompanyChange(companyName, companyId, isInit) {
      this.data.companyId = companyId ? companyId : ''
      if (companyName) {
        queryCustomerByName(
          {
            customerName: companyName
          }
        ).then( response => {
          if (response.data && response.data.id) {
            this.data.customerId = response.data.id
            this.customerChange(this.data.customerId)
            if (!isInit) {
              this.$refs['addForm'].validateField('businessName')
            }
            this.$refs['addForm'].validateField('mobile')
          } else {
            this.data.customerId = null
          }
        }).catch(error => {
          this.data.customerId = null
        })
      } else {
        this.data.customerId = null
      }
    },
    checkBusiness (rule, value, callback) {
      // 必填
      if (!value) {
        callback(new Error("请输入商机名称"))
      } else {
        // 客户已存在，才去校验。所以需要在填写客户名称后再手动触发下校验
        if (this.data.customerId) {
          businessNameCheck(
            {
              businessName: value,
              customerId: this.data.customerId
            }
          ).then( response => {
            if (response.data && response.data.id) {
              callback(new Error("商机名称已存在，请重新输入"))
            } else {
              callback()
            }
          }).catch(error => {
            callback()
          })
        } else {
          callback()
        }
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          convertToBusiness(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("转商机成功");
          }).catch(error => {
            loading.close()
          })
        }
      });
    }
  }
};
</script>
